import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AlvaroC_Video3 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoAlvaro3 = () => {
  return (
    <>
      <ModalVideo
        id="alvaro-video-3"
        dataText={AlvaroC_Video3}
        videoSrc="https://www.youtube.com/embed/t6kqFYdv3I8?si=5yEAIpb4oFS3vycZ"
        videoTitle="KUTER_STUDIO_AI_ALVARO_VIDEO_3"
      />
    </>
  );
};

export default ModalVideoAlvaro3;
